import api from "./index";

export const tasksAPI = {
  getAll: (params) => api.get("/tasks", { params }),
  getById: (id) => api.get(`/tasks/${id}`),
  create: (data) => api.post("/tasks", data),
  update: (id, data) => api.put(`/tasks/${id}`, data),
  delete: (id) => api.delete(`/tasks/${id}`),
  updateStatus: (id, data) => api.put(`/tasks/${id}/status`, data),
  assign: (id, data) => api.post(`/tasks/${id}/assign`, data),
  addDependency: (id, data) => api.post(`/tasks/${id}/dependency`, data),
};
